import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

export default generateCarleadCreationConfig({
  ...DEFAULT_CARLEAD_CONFIGS['es-ES'],
  marketingAttributes: {
    ...DEFAULT_CARLEAD_CONFIGS['es-ES'].marketingAttributes,
    'lead-step-indicator-202509-v1': 0,
    'lead-channel-selection-032026-v1': 1,
  },
  minimumMileage: true,
});
